var map = {
	"./acme/lang.json": 1029,
	"./audacy/lang.json": 1030,
	"./flipkart/lang.json": 1031,
	"./foobars_store/lang.json": 1032,
	"./hotstar/lang.json": 1033,
	"./walmart/lang.json": 1034,
	"./walmartcam/lang.json": 1035,
	"./walmartcentralamerica/lang.json": 1036,
	"./walmartchile/lang.json": 1037
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1028;